export const glassDefaults = {
    // Core surfaces
    VSheet: { elevation: 0, class: 'glass' },
    VCard: { elevation: 0, class: 'glass' },
    VToolbar: { elevation: 0, class: 'glass' },
    VAppBar: { elevation: 0, class: 'glass' },
    VFooter: { elevation: 0, class: 'glass' },
    VNavigationDrawer: { elevation: 0, class: 'glass' },

    // Common widgets
    VList: { elevation: 0, class: 'glass' },
    VExpansionPanels: { class: 'glass' },
    VExpansionPanel: { elevation: 0, class: 'glass' },
    VDataIterator: { class: 'glass' },
    VDataTable: { density: 'comfortable', class: 'glass text-body-1' },

    // Overlays are styled via overlay CSS (see glass.css)
    VMenu: { elevation: 0 },
    VDialog: {
        elevation: 0,
        contentClass: 'app-dialog-bordered',
    },
    VTooltip: { elevation: 0 },

    // Forms
    VTextField: {
        variant: 'filled',
        elevation: 0,
        class: 'glass-input',
        color: 'rgba(154,199,250,0.68)',
    },
    VTextarea: { variant: 'filled', elevation: 0, class: 'glass-input' },
    VSelect: { variant: 'filled', elevation: 0, class: 'glass-input' },
    VAutocomplete: { variant: 'filled', elevation: 0, class: 'glass-input' },

    VBtn: { variant: 'text', elevation: 0, class: 'glass' },
    VSlideGroup: {
        class: 'glass',
    },
};
